import { SCREEN_IDS, typeConnect } from "../../constants/Constants";
import { getFullMo } from "../ConnectDataBase";

const SCREEN_NAME = "FindingsWeighingScreen";

/**
 * Líneas de fornitura pendientes de pesar para una MO (misma fuente que P. Fornituras).
 */
export async function fetchForniturasPendientesForMo(mo) {
  if (!mo) return [];

  const fullMo = await getFullMo(
    SCREEN_NAME,
    typeConnect[0],
    SCREEN_IDS.FINDINGS_WEIGHT
  );

  if (!fullMo || typeof fullMo !== "object") return [];

  return Object.entries(fullMo)
    .map(([key, data]) => ({
      key,
      po: data.po ?? key,
      ...data,
    }))
    .filter((item) => item.mo === mo);
}

export async function countForniturasPendientesForMo(mo) {
  const rows = await fetchForniturasPendientesForMo(mo);
  return rows.length;
}
